var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import lodash from 'lodash';
import { action, observable } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics, BaseModel } from './../../libraries';
import { createUserModel } from './userInfo';
export class LuckyController {
    constructor() {
        this.Model = new BaseModel({
            type: 'object',
            storageLoading: false,
        });
        //用户数据
        this.UserInfo = createUserModel();
        //是否参加过本次抽奖
        this.currentLuckStatus = false;
        //是否参加过当前直播间抽奖
        this.luckStatus = false;
        this.luckyResult = null;
    }
    get liveId() {
        return lodash.get(this.UserInfo.value, 'liveId');
    }
    get userCode() {
        return lodash.get(this.UserInfo.userInfo, 'userCode');
    }
    get userName() {
        return lodash.get(this.UserInfo.userInfo, 'userName', '游客');
    }
    //参加抽奖提交信息
    get luckyUser() {
        return lodash.get(this.Model.value, 'luckyUser');
    }
    //本次抽奖信息
    get luckyInfo() {
        return lodash.get(this.Model.value, 'luckyInfo');
    }
    get LuckyHistory() {
        return lodash.get(this.Model.value, 'LuckyHistory');
    }
    //最近一次抽奖信息
    get lastLuckyInfo() {
        return lodash.get(this.Model.value, 'lastLuckyInfo');
    }
    //收货地址信息
    get address() {
        return lodash.get(this.luckyInfo, 'address');
    }
    //收货地址信息placeholder
    get addressGuideMsg() {
        return (lodash.get(this.address, 'guide_msg') ||
            '请填写详细地址、收件人和联系方式');
    }
    //收货地址信息label
    get addressName() {
        return lodash.get(this.address, 'name') || '填写邮寄信息';
    }
    //是否需要填写收货地址
    get isShowAddress() {
        return lodash.eq(lodash.get(this.address, 'is_show'), 1);
    }
    //开奖时间
    get deadline() {
        return lodash.get(this.luckyInfo, 'deadline');
    }
    //是否自动开奖
    get autoopen() {
        return lodash.get(this.luckyInfo, 'auto_open');
    }
    //参加过抽奖的直播间ID 用于判断是否参加过当前直播间的抽奖
    get isLuckyliveId() {
        return lodash.get(this.Model.value, 'liveId');
    }
    //当前抽奖id
    get ldRecordId() {
        return lodash.get(this.luckyInfo, 'ld_record_id');
    }
    //当前抽奖名称
    get awardName() {
        return lodash.get(this.luckyInfo, 'award_name');
    }
    //是否正在抽奖
    get isLuckying() {
        return !lodash.eq(lodash.get(this.lastLuckyInfo, 'remark'), lodash.get(this.luckyInfo, 'award_name'));
        // return  !lodash.eq(
        //   lodash.get(this.lastLuckyInfo, 'ld_record_id'),
        //   lodash.get(this.luckyInfo, 'ld_record_id'),
        // )
    }
    //是否显示转盘
    get isShowLucky() {
        return this.isLuckying || this.currentLuckStatus || this.luckStatus;
    }
    // luckyResult = {
    //   is_lucky: false, remark: 'iphone 一部', ld_record_id: '22222', luckers: [
    //     {
    //       "uname": "张先生",
    //       "voucher": "1655564432",
    //       "remark": "iphone 一部"
    //     },
    //     {
    //       "uname": "李先生",
    //       "voucher": "16654335267",
    //       "remark": "iphone 一部"
    //     }
    //   ]
    // }
    setLuckyResult(info) {
        this.luckyResult = info;
    }
    setState(name, data) {
        this[name] = data;
    }
    /**
     * 获取抽奖信息
     */
    onGetLuckyInfo() {
        return new Promise((resolve, reject) => {
            Mudu.Room.LuckyDraw.Get((response) => {
                response = JSON.parse(response);
                if (response.status === 'y') {
                    const luckyDraw = lodash.get(response.data, 'lucky_draw', {});
                    this.Model.merge({ luckyInfo: luckyDraw });
                    resolve(luckyDraw);
                }
                if (response.status === 'n') {
                    console.log('获取失败');
                    reject(response);
                }
            });
        });
    }
    /**
     * 抽奖报名
     */
    onLuckySign(formState) {
        return new Promise((resolve, reject) => {
            const param = formState || this.luckyUser || {};
            Mudu.Room.LuckyDraw.SignUp(param, 
            // 回调函数，参数为response
            (response) => {
                response = JSON.parse(response);
                if (response.status === 'y') {
                    //如果formState不为空切报名成功 说明是第一次填写内容
                    if (formState && !lodash.isEmpty(formState)) {
                        //给后台发送抽奖信息
                        this.onSubmitLuckyInfo(formState);
                        //存储liveId
                        this.Model.merge({ luckyUser: formState, liveId: this.liveId });
                    }
                    resolve(response);
                }
                if (response.status === 'n') {
                    if (lodash.includes([101], response.flag) &&
                        !lodash.isEmpty(param)) {
                        this.Model.merge({ luckyUser: param, liveId: this.liveId });
                    }
                    console.log(response.info || '抽奖报名失败');
                    reject(response);
                }
            });
        });
    }
    /**
     * 获取开奖历史列表
     */
    onLuckyHistory() {
        return new Promise((resolve, reject) => {
            Mudu.Room.LuckyDraw.GetAllResult(
            // 回调函数，参数为response对象
            (response) => {
                response = JSON.parse(response);
                if (response.status === 'y') {
                    console.log('获取开奖历史', response.data);
                    this.Model.merge({ lastLuckyInfo: lodash.head(response.data) });
                    this.Model.merge({ LuckyHistory: response.data });
                    resolve(response.data);
                }
                if (response.status === 'n') {
                    console.log('获取失败');
                    reject(response);
                }
            });
        });
    }
    /**
     * 获取收货地址
     */
    onGetAddress(recordId) {
        return new Promise((resolve, reject) => {
            Mudu.Room.LuckyDraw.GetAddress(recordId, (response) => {
                response = JSON.parse(response);
                if (response.status === 'y') {
                    resolve(response.data);
                }
                if (response.status === 'n') {
                    console.log('获取失败');
                    reject('获取失败');
                }
            });
        });
    }
    /**
     * 提交收货地址
     */
    onSetAddress(recordId, address) {
        return new Promise((resolve, reject) => {
            Mudu.Room.LuckyDraw.SetAddress(address, recordId, (response) => {
                response = JSON.parse(response);
                if (response.status === 'y') {
                    resolve('提交成功');
                }
                if (response.status === 'n') {
                    console.log('提交失败');
                    reject('提交失败');
                }
            });
        });
    }
    onLuckyListener() {
        //LuckyDraw.Open事件会在后台开奖的时候被触发
        try {
            Mudu.MsgBus.On(
            // 事件名，值为LuckyDraw.Open
            'LuckyDraw.Open', 
            // 事件处理函数
            (response) => {
                response = JSON.parse(response);
                if (response.status === 'y') {
                    this.onLuckyInit();
                    this.setLuckyResult(response.data);
                }
                if (response.status === 'n') {
                    this.setLuckyResult(null);
                    console.log('获取失败');
                }
            });
            //LuckyDraw.ConfigChange事件会在控制台保存抽奖配置时触发
            Mudu.Room.LuckyDraw.On('LuckyDraw.ConfigChange', (msg) => {
                const config = JSON.parse(msg).data;
                this.onLuckyInit();
                this.Model.merge({ luckyInfo: config });
            });
        }
        catch (error) { }
    }
    /**
     * @description: 查询是否参与过本次抽奖
     */
    async getCurrentLuckStatus() {
        const body = {
            liveId: this.liveId,
            userName: this.userName,
            userCode: this.userCode,
            ldRecordId: this.ldRecordId,
            awardName: this.awardName,
        };
        try {
            const currentLuckStatus = await AjaxBasics.request(lodash.assign(EnumAPI.live_lottery_single, {
                body,
            }));
            this.setState('currentLuckStatus', currentLuckStatus);
        }
        catch (error) { }
    }
    /**
     * @description: 查询是否参与过本次直播的抽奖
     */
    async getLuckStatus() {
        const body = {
            liveId: this.liveId,
            userName: this.userName,
            userCode: this.userCode,
        };
        try {
            const luckStatus = await AjaxBasics.request(lodash.assign(EnumAPI.live_lottery, {
                body,
            }));
            this.setState('luckStatus', luckStatus);
        }
        catch (error) { }
    }
    /**
     * @description: 提交抽奖信息 让后台记录
     */
    async onSubmitLuckyInfo(formState) {
        const body = {
            liveId: this.liveId,
            userName: this.userName,
            userCode: this.userCode,
            ldRecordId: this.ldRecordId,
            awardName: this.awardName,
            lotteryMessage: JSON.stringify(formState) || JSON.stringify(this.luckyUser),
        };
        try {
            await AjaxBasics.request(lodash.assign(EnumAPI.live_lottery_save, {
                body,
            }));
            this.getCurrentLuckStatus();
        }
        catch (error) { }
    }
    async onLuckyInit() {
        try {
            await this.onGetLuckyInfo();
            await this.onLuckyHistory();
        }
        catch (error) {
            this.Model.merge({ luckyInfo: {} });
            this.Model.merge({ lastLuckyInfo: {} });
        }
        //存在userCode说明登录了
        if (this.userCode) {
            //查询是否参与过本次抽奖
            await this.getCurrentLuckStatus();
            //查询是否参与过本次直播抽奖
            await this.getLuckStatus();
        }
        else {
            this.setState('currentLuckStatus', false);
            this.setState('luckStatus', false);
        }
    }
}
__decorate([
    observable
], LuckyController.prototype, "currentLuckStatus", void 0);
__decorate([
    observable
], LuckyController.prototype, "luckStatus", void 0);
__decorate([
    observable
], LuckyController.prototype, "luckyResult", void 0);
__decorate([
    action.bound
], LuckyController.prototype, "setLuckyResult", null);
__decorate([
    action.bound
], LuckyController.prototype, "setState", null);
